export default __webpack_public_path__ + "static/logo-4fa254ce3e214a001b466e49d929db45.png";